import React from 'react';
import stylesRV from '../RateView.module.css';

import UshExportModal from '../modal/UshExportModal';

import { getCurrentResource } from '../../../util/tools';
import { canPerformAction, getButtonMode } from '../../../util/localStorage';
import { ACTION_USH_EXPORT } from '../../../util/consts/actions';

import exportIcon from '../../../assets/icons/png24x24/Upload.png';

class ButtonUshExport extends React.Component {
	
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.rateview.button.ButtonUshExport;
		this.rateView = props.holder;
		this.componentUshExportModal = null;
		this.state = {
			isExportModalOpen: false
		}
	}

	doExport = () => {
		if( this.componentUshExportModal )
			this.componentUshExportModal.init();
		this.setState({ isExportModalOpen: true });	
	}	
	closeExport = () => {
		this.setState({ isExportModalOpen: false });	
	}
	
	render() {
		if( this.props.holder.props.rvOptions.hideButtonUshExport )
			return null;
		if( ! canPerformAction( ACTION_USH_EXPORT ) )
			return ( null );
		var buttonStyle = this.props.buttonStyle ? this.props.buttonStyle : {}; 
	
		var buttonStyle = this.props.buttonStyle ? this.props.buttonStyle : {}; 
		if( getButtonMode() == 'icon' ) {
			var button = (
				<button 
					type="button"
					className={stylesRV.buttonToolbarIcon} style={buttonStyle} 
					onClick={this.doExport} 
					title={this.resource.buttonExportTooltip}
				>
					<img src={exportIcon} />
				</button>
			);
		} else {
			var button = (
				<button 
					type="button"
					className={stylesRV.buttonToolbarText} style={buttonStyle} 
					onClick={this.doExport}
					title={this.resource.buttonExportTooltip}
				>
					{this.resource.buttonExport}
				</button>
			);
		}
	
		return (
			<React.Fragment>
				{button}
				<UshExportModal 
					isModalOpen={this.state.isExportModalOpen} 
					close={this.closeExport} 
					holder={this} rvContext={this.props.holder.rvContext} />
			</React.Fragment>
		);
	}
	
}

export default ButtonUshExport;
